import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, formatDate } from "@/lib/api";
import { ArticleCard } from "@/components/ArticleCard";
import { SEO } from "@/components/SEO";

export default function PodcastDetailPage() {
  const { slug } = useParams();
  const [episode, setEpisode] = useState(null);
  const [related, setRelated] = useState([]);

  useEffect(() => {
    api.get(`/podcasts/${slug}`).then(({ data }) => setEpisode(data));
  }, [slug]);

  useEffect(() => {
    if (!episode?.category_id) return;
    api.get("/categories").then(({ data }) => {
      const cat = data.find((c) => c.id === episode.category_id);
      if (cat) api.get("/articles", { params: { category: cat.slug, limit: 4 } }).then(({ data }) => setRelated(data.items));
    });
  }, [episode]);

  if (!episode) return <div className="p-24 text-center text-[#66717B]">Зареждане...</div>;

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10" data-testid="podcast-detail-page">
      <SEO title={episode.title} description={episode.description} image={episode.thumbnail} />
      <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#C47A35]">Подкаст</span>
      <h1 className="font-serif text-3xl sm:text-4xl font-bold text-[#10243A] mt-2" data-testid="podcast-detail-title">{episode.title}</h1>
      <div className="mt-3 text-sm text-[#66717B]">
        {episode.guest && <span>Гост: {episode.guest} &middot; </span>}
        <span>{formatDate(episode.published_at)}</span>
      </div>
      <div className="aspect-video mt-6 bg-black">
        <iframe
          className="w-full h-full"
          src={`https://www.youtube.com/embed/${episode.youtube_video_id}`}
          title={episode.title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          data-testid="podcast-youtube-embed"
        />
      </div>
      <p className="mt-6 text-base sm:text-lg text-[#20252B] leading-relaxed">{episode.description}</p>
      <a href={episode.youtube_url} target="_blank" rel="noopener noreferrer" className="inline-block mt-4 text-sm font-semibold text-[#A6631F] hover:underline" data-testid="podcast-youtube-link">
        Гледай в YouTube &rarr;
      </a>

      {related.length > 0 && (
        <section className="mt-16 pt-10 border-t border-[#E4E7E9]">
          <h3 className="font-serif text-2xl font-bold text-[#10243A] mb-6">Свързани статии</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {related.map((a) => <ArticleCard key={a.id} article={a} variant="compact" />)}
          </div>
        </section>
      )}
    </div>
  );
}
